import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Nomenclature, NomenclatureCreatePayload, NomenclaturesService } from '../../../services/nomenclatures.service';

@Component({
  selector: 'app-creer-nomenclature',
  imports: [CommonModule, FormsModule],
  templateUrl: './creer-nomenclature.component.html',
  styleUrl: './creer-nomenclature.component.scss'
})
export class CreerNomenclatureComponent implements OnInit {
  protected nomenclatures: Nomenclature[] = [];
  protected numeroNomenclature: string | number = '';
  protected nom = '';
  protected dateCreation = '';
  protected sourceNomenclatureId = '';
  protected loading = false;
  protected loadingNomenclatures = false;
  protected success = '';
  protected error = '';

  constructor(
    private readonly nomenclaturesService: NomenclaturesService,
    private readonly zone: NgZone,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const today = new Date().toISOString().split('T')[0];
    this.dateCreation = today;
    this.loadNomenclatures();
  }

  protected submit(): void {
    this.error = '';
    this.success = '';

    const numeroNomenclature = String(this.numeroNomenclature ?? '').trim();
    const numeroNomenclatureValue = Number(numeroNomenclature);

    if (!numeroNomenclature || Number.isNaN(numeroNomenclatureValue) || !Number.isInteger(numeroNomenclatureValue)) {
      this.error = 'Le numéro de nomenclature est requis.';
      return;
    }
    if (numeroNomenclature.length > 9) {
      this.error = 'Le numéro de nomenclature ne doit pas dépasser 9 caractères.';
      return;
    }

    const nom = this.nom.trim();
    if (!nom) {
      this.error = 'Le nom de la nomenclature est requis.';
      return;
    }

    const payload: NomenclatureCreatePayload = {
      numero_nomenclature: numeroNomenclatureValue,
      nom,
      date_creation: this.dateCreation || undefined,
      source_nomenclature_id: this.sourceNomenclatureId ? Number(this.sourceNomenclatureId) : undefined
    };

    this.loading = true;
    this.zone.run(() => {
      this.nomenclaturesService.create(payload).subscribe({
        next: () => {
          this.success = 'Nomenclature créée avec succès.';
          this.resetForm();
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: (err: HttpErrorResponse) => {
          this.error = `Erreur lors de la création: ${this.getErrorMessage(err)}`;
          this.loading = false;
          this.cdr.markForCheck();
        }
      });
    });
  }

  private resetForm(): void {
    this.numeroNomenclature = '';
    this.nom = '';
    this.sourceNomenclatureId = '';
    const today = new Date().toISOString().split('T')[0];
    this.dateCreation = today;
  }

  private loadNomenclatures(): void {
    this.loadingNomenclatures = true;
    this.zone.run(() => {
      this.nomenclaturesService.list().subscribe({
        next: (nomenclatures: Nomenclature[]) => {
          this.nomenclatures = nomenclatures;
          this.loadingNomenclatures = false;
          this.cdr.markForCheck();
        },
        error: (err: HttpErrorResponse) => {
          this.error = `Erreur lors du chargement des nomenclatures: ${this.getErrorMessage(err)}`;
          this.loadingNomenclatures = false;
          this.cdr.markForCheck();
        }
      });
    });
  }

  private getErrorMessage(err: HttpErrorResponse): string {
    if (typeof err.error === 'string' && err.error.trim()) {
      return err.error;
    }

    if (err.error?.detail) {
      return err.error.detail;
    }

    if (err.error?.message) {
      return err.error.message;
    }

    return err.statusText || 'Erreur inconnue';
  }
}
